import React from 'react';
import RichText from '../../utils/RichText';
import './ProductFormModal.scss';
import {simpleNotification} from "../../utils/notifications";
import moment from "moment/moment";
import {getDefaultIcon, isQuestTimeSetValid} from "../../utils/functions";
import Dropzone from "react-dropzone";
import classNames from "classnames";
// import Select from 'react-select';

const coverImg = ['.jpg', '.png'];

class ProductFormModal extends React.Component {
  constructor(props) {
    super(props);

    const { product, isEditMode } = props;

    this.state = {
      productName: isEditMode && product ? product.name : '',
      category: isEditMode && product ? product.type : '',
      platform: isEditMode && product ? product.platform : '',
      price: isEditMode && product ? product.price : '',
      commissionRate: isEditMode && product ? product.commission : '',
      status: isEditMode && product ? product.active===1?'listing':'unlisted' : 'listing',
      imagePreview: isEditMode && product ? product.cover : null,
      description: isEditMode && product ? product.description : '',
      cdkQuantity: isEditMode && product ? product.cdKeys?.length : 0,
      file:'',
      fileCsv:'',
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.preSignedUrl.isLoading === true && this.props.preSignedUrl.isLoading === false) {
      const { data: signedUrl } = this.props.preSignedUrl;
      this.uploadToS3(this.state.file, signedUrl.preSignedUrl);
    }
    if (prevProps.cdkeys.isLoading === true && this.props.cdkeys.isLoading === false) {
      if (this.props.cdkeys.errors.hasError) {
        simpleNotification({
          level: "error",
          title: this.props.cdkeys.errors.message,
          message: "file failed to upload!",
        });
      }else{
        const { data } = this.props.cdkeys;
        const allTotal = data?.allTotal||0;
        this.setState({cdkQuantity:allTotal});
        if(this.props.cdkeys.code==='E_NO_VALID_CDKEYS'){
          simpleNotification({
            level: "error",
            title: "Invalid KEY",
            message: `There are ${this.props.cdkeys.data?.repeatedKeys?.length} invalid keys present`,
          });
        }else if(this.props.cdkeys.code==='E_FINDING_DUPLICATED_KEY'){
          simpleNotification({
            level: "error",
            title: "Duplicate KEY",
            message: `There are ${this.props.cdkeys.data?.repeatedKeys?.length} duplicate keys present`,
          });
        }else {
          // simpleNotification({
          //   level: "info",
          //   title: "upload key success",
          //   message: `There are ${this.props.cdkeys.data?.createdTotal||allTotal} valid  keys,${this.props.cdkeys.data?.repeatedTotal||0} repeated  keys`,
          // });
        }
      }
    }

    const { product, isEditMode } = this.props;
    if (prevProps.saleProduct.isLoading === true && this.props.saleProduct.isLoading === false) {
      if (this.props.saleProduct.errors.hasError) {
        simpleNotification({
          level: "error",
          title: this.props.saleProduct.errors.message,
          message: `project failed to ${isEditMode && product ?'edit':'create'}!`,
        });
      }else{
        const { data } = this.props.saleProduct;
        if(!data?.id){
          console.error('product id not exist');
          return;
        }
        simpleNotification({
          level: "info",
          title: `Product ${isEditMode && product ?'edit':'creation'} successful`,
          message: `project success to ${isEditMode && product ?'edit':'creation'}!`,
        });
        //this.setState({cdkQuantity:data?.allTotal||0});
        // const { onClose} = this.props;
        //onClose();
        //upload
        const {csvFile} = this.state;
        if(!csvFile){
          console.log('csvFile not exist');
          this.closeDialog();
          return;
        }
        const formData = new FormData();
        formData.append('file', csvFile);
        // Upload the file
        const { token } = this.props.auth;
        this.props.uploadSaleProductCDKeys(formData, data?.id,1,'platform', token);
        this.closeDialog();
      }
    }
  }

  componentDidMount() {
    // const { token } = this.props.auth;
    // this.props.getAllPlatforms(token);
    //this.props.getAllSaleProductTypes(token);
  }

  closeDialog = ()=>{
    this.setState({productName:"",category:"",platform:"",price:"",commissionRate:"",status:"listing",imagePreview:null,description:"",cdkQuantity:0,file:"",fileCsv:""});
    const { onClose} = this.props;
    onClose();
  }

  uploadToS3 = (file, preSignedUrl) => {
    // const { image } = this.state;
      if (file.size > 700000) {
        simpleNotification({
          level: 'warning',
          title: 'Warning',
          message: 'Image has a limit of 700kb.',
        });
        this.setState({
          activeModal: 1,
        });
        return;
      }
    this.setState({ activeModal: 2 });
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', preSignedUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.addEventListener('load', this.handleLoad);
    xhr.send(file);
  }

  handleLoad = (event) => {
    const { preSignedUrl: { data: signedUrl }} = this.props;
    // const { image } = this.state;

    if (event.target.status !== 200) {
      this.setState({
        activeModal: 0,
      });
      simpleNotification({
        level: 'error',
        title: 'Error',
        message: 'Error uploading the image, try again please.',
      });
      return;
    }

    // simpleNotification({
    //   level: 'success',
    //   title: 'Success',
    //   message: 'The image was uploaded succesfully!',
    // });

    // if (image === 'coverPortrait') {
    //   updateTwitchDropForm({ coverPortrait: signedUrl.url });
    // }else if (image === 'coverBannel') {
    //   updateTwitchDropForm({ coverBannel: signedUrl.url });
    // }else if (image === 'background') {
    //   updateTwitchDropForm({ background: signedUrl.url });
    // }
    this.setState({ activeModal: 0 ,imagePreview:signedUrl?.url});
  }

  handleInputChange = (field, value) => {
    let fValue = value;
    if(field==="price"){
      fValue = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.\d{2}).*/g, '$1').replace(/^0+(\d)/, '$1');
    }else if(field==="commissionRate"){
      fValue = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.\d{2}).*/g, '$1').replace(/^0+(\d)/, '$1');
      if(fValue>100){
        fValue=100;
      }
    }
    this.setState({ [field]: fValue||0 });
  }

  handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ imagePreview: reader.result });
      };
      reader.readAsDataURL(file);
    }
  }

  onDrop = (files, e) => {
    const file = files && files.length ? files[0] : e[0];
    this.setState({
      // dropzoneActive: false,
      file,
    });
    // const { image } = this.state;
    const format = file.name.split('.')[1];
    if(coverImg.findIndex(c=>c.slice(1)===format)<0){
      simpleNotification({
        level: 'error',
        title: 'The file format is incorrect',
        message: 'Please select a image file type!',
      });
      return;
    }
    const { auth: { token }, requestUploadImageUrl } = this.props;
    // const slug = this.getSlug();
      requestUploadImageUrl('product', format, token, {
        entityType: 'products',
        field: 'cover',
      });


    //this.setState({ activeModal: 2 });
  }

  onCsvDrop = (files, e) => {
    const file = files && files.length ? files[0] : e[0];
    this.setState({
      // dropzoneActive: false,
      csvFile:file,
    });
    const format = file.name.split('.')[1];
    const { auth: { token } } = this.props;
    // const slug = this.getSlug();
    if(format!=='csv'){
      simpleNotification({
        level: 'error',
        title: 'The file format is incorrect',
        message: 'Please select a CSV file type!',
      });
      return;
    }

    if(!this.isProductPlatformValid()){
      simpleNotification({
        level: "error",
        title: "Invalid product platform",
        message: "Please select a platform!",
      });
      return;
    }
    const {platform} = this.state;
    const formData = new FormData();
    formData.append('file', file);
    // Upload the file
    this.props.uploadSaleProductCDKeys(formData, 0,1,platform, token);

    //this.setState({ activeModal: 2 });
  }

  handleSave = () => {
    const { onSave } = this.props;
    const formData = {
      productName: this.state.productName,
      category: this.state.category,
      platform: this.state.platform,
      price: parseFloat(this.state.price),
      commissionRate: parseFloat(this.state.commissionRate),
      status: this.state.status,
      image: this.state.imagePreview,
      description: this.state.description,
      stock: this.state.cdkQuantity,
    };

    if (onSave) {
      onSave(formData);
    }
  }

  isFormValid = () => {
    return this.isProductNameValid() && this.isProductCategoryValid() && this.isProductPlatformValid() && this.isSalePriceValid() && this.isCommissionRateValid() && this.isProductCoverValid();
  }

  isProductNameValid = () =>{
    const { productName } = this.state;
    if(!productName||productName.trim().length<1){
      return false;
    }
    return true;
  }

  isProductCategoryValid = () =>{
    const { category } = this.state;
    if(!category||category.trim().length<1){
      return false;
    }
    return true;
  }

  isProductPlatformValid = () =>{
    const { platform } = this.state;
    if(!platform||platform.trim().length<1){
      return false;
    }
    return true;
  }

  isSalePriceValid = () =>{
    const { price } = this.state;
    const num = Number(price);
    if (typeof num !== 'number' || !Number.isFinite(num) || num<=0) {
      return false;
    }
    const priceRegex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
    if(!price||price.toString().length<1||!priceRegex.test(price.toString())){
      return false;
    }
    return true;
  }

  isCommissionRateValid = () =>{
    const { commissionRate } = this.state;
    const num = Number(commissionRate);
    if (typeof num !== 'number' || !Number.isFinite(num)) {
      return false;
    }
    return num >= 0 && num <= 100;
  }

  isProductCoverValid = () =>{
    const { imagePreview } = this.state;
    if(!imagePreview||imagePreview.trim().length<1){
      return false;
    }
    return true;
  }

  platformOptions = () => {
    const { properties } = this.props;
    return properties?.platformGuides?.map(p=>p.platform)||[];
    // const { platforms } = this.props;
    // const grouped = platforms.reduce((acc, platform) => {
    //   if (!acc[platform.baseService]) {
    //     acc[platform.baseService] = [];
    //   }
    //   acc[platform.baseService].push(platform);
    //   return acc;
    // }, {});
    //
    // return Object.keys(grouped).map(group => ({
    //   label: group,
    //   options: grouped[group].map(({ id, platform }) => ({
    //     value: id,
    //     label: platform,
    //   })),
    // }));
  }

  productTypeOptions = () => {
    const { properties } = this.props;
   return properties?.types||[];
  }

  processProduct=(event)=>{
    event.preventDefault();
    //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
    if(!this.isProductNameValid()){
      simpleNotification({
        level: "error",
        title: "Invalid product name",
        message: "Please enter the product name!",
      });
      return;
    }

    if(!this.isProductPlatformValid()){
      simpleNotification({
        level: "error",
        title: "Invalid product platform",
        message: "Please select a platform!",
      });
      return;
    }


    if(!this.isSalePriceValid()){
      simpleNotification({
        level: "error",
        title: "The selling price is incorrect",
        message: "Please enter the correct price!",
      });
      return;
    }
    if(!this.isCommissionRateValid()){
      simpleNotification({
        level: "error",
        title: "The commission rate is incorrect",
        message: "Please enter the correct commission rate!",
      });
      return;
    }

    if(!this.isProductCoverValid()){
      simpleNotification({
        level: "error",
        title: "Cover not uploaded",
        message: "Please upload the cover!",
      });
      return;
    }
    const salePrice = Number(this.state.price).toFixed(2);
    const comissionRate = Number(this.state.commissionRate).toFixed(2)
    // const data = {productName:this.state.productName,productPlatform:this.state.productPlatform,productPrice:this.state.productPrice};
    // const { token } = this.props.auth;
    // console.log(this.state.productName,this.state.platform,this.state.category,salePrice,comissionRate,this.state.imagePreview,this.state.description,this.state.status);
    this.props.onSave(this.props.product,{productName:this.state.productName,productPlatform:this.state.platform,productType:this.state.category,salePrice,comissionRate,imagePreview:this.state.imagePreview,description:this.state.description,status:this.state.status});
    //this.setState({ regionName: "",currencyName:this.currys[0].code,timezoneName:this.timezones[0]});
    //this.handleRegionClose();
    //this.setState({ regionsSubmit: true});
    //simpleNotification({
    //  level: "success",
    //  title: "Region add successful.",
    //  message: "Region has not been permanently saved yet. Please set up the application in a timely manner to save it!",
    //});

  }

  submit = (questFormInformation) => {
    alert(questFormInformation);
    const {
      autoStreamingQuest,
      secondaryCreationQuest,
      isNewTypeQuest,
    } = this.getQuestTypeFlags();

    const { game, onSubmit, quest } = this.props;
    const { prevGamesPlayed } = this.state;
    // 创建新对象，避免修改原始表单值
    // 对于需要转换的字段，在复制时进行转换
    const questFormInfo = {
      ...questFormInformation,
      // 转换 platforms
      platforms: questFormInformation.platforms&&questFormInformation.platforms.length>0
          ? questFormInformation.platforms.map(p => p.value)
          : [],
      // 转换 countries
      countries: questFormInformation.countries && questFormInformation.countries.length > 0
          ? questFormInformation.countries.map(c => c?.value)
          : questFormInformation.countries,
      // 转换 languages
      languages: questFormInformation.languages && questFormInformation.languages.length > 0
          ? questFormInformation.languages.map(l => l.value)
          : questFormInformation.languages,
    };
    const requiredDateTimeStart = moment(questFormInfo.requiredStartDateTime, 'YYYY-MM-DD');
    const requiredDateTimeEnd = moment(questFormInfo.requiredEndDateTime, 'YYYY-MM-DD');
    const range = requiredDateTimeEnd.diff(requiredDateTimeStart, 'minutes');
    questFormInfo.requiredStreamRangeTime = range;
    questFormInfo.requiredStreamTimeHours = 24;
    if (questFormInfo.requiredStreamTimeMinutes) {
      questFormInfo.requiredStreamTimeMinutes = parseInt(questFormInfo.requiredStreamTimeMinutes, 10);
    }

    if (questFormInfo.paymentAmount) {
      questFormInfo.paymentAmount = parseInt(questFormInfo.paymentAmount, 10);
    }

    if (questFormInfo.dailyEarning) {
      questFormInfo.dailyEarning = parseInt(questFormInfo.dailyEarning, 10);
    }

    if (questFormInfo.miniFollowers) {
      questFormInfo.miniFollowers = parseInt(questFormInfo.miniFollowers, 10);
    }


    if (questFormInfo.viewerTiers && questFormInfo.viewerTiers.length > 0) {
      const isYoutubeVideoQuest = questFormInfo.type === 'youtube-video';
      for (let i = 0; i < questFormInfo.viewerTiers.length; i += 1) {
        questFormInfo.viewerTiers[i].spotsAvailable = parseInt(questFormInfo.viewerTiers[i].spotsAvailable, 10);
        questFormInfo.viewerTiers[i].paymentAmount = parseFloat(questFormInfo.viewerTiers[i].paymentAmount, 10);

        // Parse metric field based on quest type
        if (isYoutubeVideoQuest) {
          if (questFormInfo.viewerTiers[i].minimumAveragePlayCount !== undefined) {
            questFormInfo.viewerTiers[i].minimumAveragePlayCount = parseInt(questFormInfo.viewerTiers[i].minimumAveragePlayCount, 10);
          }
        } else {
          if (questFormInfo.viewerTiers[i].minimumAverageViewers !== undefined) {
            questFormInfo.viewerTiers[i].minimumAverageViewers = parseInt(questFormInfo.viewerTiers[i].minimumAverageViewers, 10);
          }
        }
      }
    }

    if (questFormInfo.memberTiers && questFormInfo.memberTiers.length > 0) {
      for (let k = 0; k < questFormInfo.memberTiers.length; k += 1) {
        const { identity, paymentAmount, type } = questFormInfo.memberTiers[k];
        questFormInfo.memberTiers[k] = {
          identity: identity?.trim(),
          paymentAmount: parseFloat(paymentAmount, 10),
          type: type?.trim(),
        };
      }
    }

    if (questFormInfo.splitTiers && questFormInfo.splitTiers.length > 0) {
      //streamDays, streamHours, maxRevenue, prizePool
      for (let i = 0; i < questFormInfo.splitTiers.length; i += 1) {
        if (autoStreamingQuest) {
          questFormInfo.splitTiers[i].streamDays = parseInt(questFormInfo.splitTiers[i].streamDays, 10);
          // questFormInfo.splitTiers[i].streamHours = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          questFormInfo.splitTiers[i].streamHours = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.splitTiers[i].totalUploadDays = parseInt(questFormInfo.splitTiers[i].totalUploadDays, 10);
          questFormInfo.splitTiers[i].validUploadCount = parseInt(questFormInfo.splitTiers[i].validUploadCount, 10);
          questFormInfo.splitTiers[i].totalViews = parseInt(questFormInfo.splitTiers[i].totalViews, 10);
        }
        questFormInfo.splitTiers[i].maxRevenue = parseInt(questFormInfo.splitTiers[i].maxRevenue, 10);
        questFormInfo.splitTiers[i].prizePool = parseInt(questFormInfo.splitTiers[i].prizePool, 10);
      }
    }

    if (questFormInfo.rankTiers && questFormInfo.rankTiers.length > 0) {
      //rankUpper, rankLower, watchTime, prize
      for (let i = 0; i < questFormInfo.rankTiers.length; i += 1) {
        questFormInfo.rankTiers[i].rankUpper = parseInt(questFormInfo.rankTiers[i].rankUpper, 10);
        questFormInfo.rankTiers[i].rankLower = parseInt(questFormInfo.rankTiers[i].rankLower, 10);
        if (autoStreamingQuest) {
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.rankTiers[i].watchTime, 10);
          questFormInfo.rankTiers[i].watchTime = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.rankTiers[i].minTotalViews = parseInt(questFormInfo.rankTiers[i].minTotalViews, 10);
        }
        questFormInfo.rankTiers[i].prize = parseInt(questFormInfo.rankTiers[i].prize, 10);
      }
    }

    questFormInfo.type = questFormInfo.type || 'one-time';

    if (questFormInfo.type === 'tiered-one-time' || questFormInfo.type === 'timed') {
      questFormInfo.frequency = 'one-time';
    }

    if (questFormInfo.type === 'tiered-multi-days' || questFormInfo.type === 'paid bounty') {
      questFormInfo.frequency = 'daily';
    }

    if (isNewTypeQuest) {
      questFormInfo.requirePreapproval = true;
      questFormInfo.frequency = 'daily';
      //判断时间
      const { valid, messages } = isQuestTimeSetValid(quest, questFormInfo);
      if (!valid) {
        simpleNotification({
          level: 'error',
          title: 'Time Validation Error',
          message: messages.join(' '),
        });
        return; // 阻止提交
      }
    }

    if (autoStreamingQuest) {
      questFormInfo.twitchAccountRequired = true;
    }

    if (secondaryCreationQuest) {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.requirePreapproval = false;
    }

    if (questFormInfo.type === 'youtube-video') {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.twitchAccountRequired = false;
    }

    questFormInfo.group = (questFormInfo.group) ? questFormInfo.group : '';

    // console.log('questFormInfo', questFormInfo);

    // 新增：验证Steam Achievement requirements
    if (questFormInfo.requirements) {
      const allRequirements = [
        ...(questFormInfo.requirements.beforeStream || []),
        ...(questFormInfo.requirements.duringStream || []),
        ...(questFormInfo.requirements.afterStream || [])
      ];

      const steamAchievementRequirements = allRequirements.filter(req => req.type === 'submit-steam-achievement');

      if (steamAchievementRequirements.length > 0) {
        // 检查游戏是否有Steam App ID
        if (!game?.steamAppId) {
          simpleNotification({
            level: 'error',
            title: 'Steam Integration Required',
            message: 'This game must have a Steam App ID to use Steam Achievement requirements.',
          });
          return;
        }

        // 验证每个Steam Achievement requirement
        for (const req of steamAchievementRequirements) {
          if (!req.gameAchievements || req.gameAchievements.length === 0) {
            simpleNotification({
              level: 'error',
              title: 'Steam Achievement Required',
              message: `Please select at least one Steam achievement for requirement "${req.title || 'Steam Achievement'}".`,
            });
            return;
          }
        }
      }
    }

    if (questFormInfo.requirements) {
      if (questFormInfo.requirements.beforeStream) {
        for (let i = 0; i < questFormInfo.requirements.beforeStream.length; i += 1) {
          const req = questFormInfo.requirements.beforeStream[i];
          delete questFormInfo.requirements.beforeStream[i].value;
          if (!req.customIcon || req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.beforeStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.beforeStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.duringStream) {
        for (let i = 0; i < questFormInfo.requirements.duringStream.length; i += 1) {
          const req = questFormInfo.requirements.duringStream[i];
          delete questFormInfo.requirements.duringStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.duringStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.duringStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.afterStream) {
        for (let i = 0; i < questFormInfo.requirements.afterStream.length; i += 1) {
          const req = questFormInfo.requirements.afterStream[i];
          delete questFormInfo.requirements.afterStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.afterStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.afterStream[i].title = '';
          }
        }
      }
    }


    questFormInfo.prevGamesPlayed = prevGamesPlayed.sort();

    onSubmit(questFormInfo);
  }

  render() {
    const { isOpen, onClose, isEditMode } = this.props;
    const {
      productName,
      category,
      platform,
      price,
      commissionRate,
      status,
      imagePreview,
      description,
      cdkQuantity,
    } = this.state;
    if (!isOpen) return null;
    return (
        <form onSubmit={this.processProduct.bind(this)}>
      <div className="product-form-modal-overlay">
        <div className="product-form-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>{isEditMode ? 'Edit Product' : 'Add New Product'}</h2>
            <button className="modal-close-btn" onClick={onClose}>
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="modal-body">
            <div className="form-columns">
              <div className="form-left">
                <div className="form-group">
                  <label>Product Name</label>
                  <input
                    type="text"
                    placeholder="Please enter the product name"
                    value={productName}
                    onChange={(e) => this.handleInputChange('productName', e.target.value)}
                    className={this.isProductNameValid()?"":"invalid"}
                  />
                </div>

                <div className="form-group">
                  <label>Product Category</label>
                  <select
                    value={category}
                    onChange={(e) => this.handleInputChange('category', e.target.value)}
                    className={this.isProductCategoryValid()?"":"invalid"}
                  >
                    <option value="">Please select a category</option>
                    {this.productTypeOptions().map(o=>(<option value={o}>{o}</option>))}
                    {/*<option value="">Please select a category</option>*/}
                    {/*<option value="Game CDK">Game CDK</option>*/}
                    {/*<option value="Gift Card">Gift Card</option>*/}
                    {/*<option value="Subscription">Subscription</option>*/}
                  </select>
                </div>

                <div className="form-group">
                  <label>Platform</label>
                  <select
                    value={platform}
                    onChange={(e) => this.handleInputChange('platform', e.target.value)}
                    className={this.isProductPlatformValid()?"":"invalid"}
                  >
                    <option value="">Please select a platform</option>
                    {/*{this.platformOptions().flatMap(o=>o.options).map(o=>(<option value={o.value}>{o.label}</option>))}*/}
                    {this.platformOptions().map(o=>(<option value={o}>{o}</option>))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Sales Price (USD)</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0.00"
                    value={price}
                    onChange={(e) => this.handleInputChange('price', e.target.value)}
                    className={this.isSalePriceValid()?"":"invalid"}
                  />
                </div>

                <div className="form-group">
                  <label>Revenue-sharing ratio</label>
                  <input
                    type="number"
                    step="1"
                    min="0"
                    max="100"
                    placeholder="0"
                    value={commissionRate}
                    onChange={(e) => this.handleInputChange('commissionRate', e.target.value)}
                    className={this.isCommissionRateValid()?"":"invalid"}
                  />
                  <span className="input-suffix">%</span>
                </div>

                <div className="form-group">
                  <label>Product Status</label>
                  <select
                    value={status}
                    onChange={(e) => this.handleInputChange('status', e.target.value)}
                    className={status?"":"invalid"}
                  >
                    <option value="listing">Listing</option>
                    <option value="unlisted">Unlisted</option>
                  </select>
                </div>
              </div>

              <div className="form-right">
                <div className="form-group">
                  <label>Main Product Image</label>
                  <div className={classNames('image-upload-area', { invalid: !imagePreview })}>
                    {imagePreview ? (
                      <div className="image-preview">
                        <img src={imagePreview} alt="Product" />
                        <button
                          className="remove-image-btn"
                          onClick={() => this.setState({ imagePreview: null })}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </div>
                    ) : (
                        <React.Fragment>
                          <Dropzone
                              ref={(node) => { this.dropzoneRef = node; }}
                              disableClick={this.state.disableClick}
                              className="Modal__upload__content"
                              onDrop={(e, event) => this.onDrop(event, e)}
                              //onDragEnter={this.onDragEnter.bind(this)}
                              //onDragLeave={this.onDragLeave.bind(this)}
                              disablePreview={false}
                              multiple={false}
                              accept={coverImg}
                              inputProps={{ id: 'file' }}
                          >
                      <label className="upload-placeholder">
                        {/*<input*/}
                        {/*  type="file"*/}
                        {/*  //accept="image/*"*/}
                        {/*  onChange={this.handleSelectedFile}*/}
                        {/*  style={{ display: 'none' }}*/}
                        {/*/>*/}
                        <i className="fa fa-cloud-upload" />
                        <p>Click to upload image</p>
                        <span className="image-size"> Mandatory Size: Less than 700kb
                          {
                              <React.Fragment><br />Recommended Dimensions: 384 x 200</React.Fragment>
                          }</span>
                      </label>
                          </Dropzone>
                        </React.Fragment>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>CDKey Information</label>
                  <div className="cdkey-info">
                    <div className="cdkey-quantity">
                      <span className="label">Inventory CDK Quantity:</span>
                      <span className="value">{cdkQuantity}</span>
                    </div>
                    <React.Fragment>
                      <Dropzone
                          ref={(node) => { this.dropzoneRef = node; }}
                          className="Modal__upload__content"
                          onDrop={(e, event) => this.onCsvDrop(event, e)}
                          //onDragEnter={this.onDragEnter.bind(this)}
                          //onDragLeave={this.onDragLeave.bind(this)}
                          disablePreview={false}
                          multiple={false}
                          accept={['.csv']}
                          inputProps={{ id: 'csvFile' }}
                      >
                    <button className="batch-import-btn" type="button">
                      <i className="fa fa-upload" /> Batch Import
                    </button>
                      </Dropzone>
                    </React.Fragment>
                    <p className="helper-text">
                      File must be a .CSV and the spreadsheet requires 'KEY' columns.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group full-width">
              <label>Product Description</label>
              <div className="product-description-editor">
                <RichText
                  initialValue={description}
                  callback={(content) => this.handleInputChange('description', content)}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-secondary" onClick={onClose}>
              CLOSE
            </button>
            <button
              className="btn-primary"
              //onClick={this.addProduct}
              disabled={!this.isFormValid()}
            >
              SAVE
            </button>
          </div>
        </div>
      </div>
        </form>
    );
  }
}

export default ProductFormModal;
// export default reduxForm({
//   form: 'saleProductForm',
//   validate,
// })(ProductFormModal);
